import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=f8dd7832"
import script from "./declaration.vue?vue&type=script&lang=js"
export * from "./declaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8dd7832')) {
      api.createRecord('f8dd7832', component.options)
    } else {
      api.reload('f8dd7832', component.options)
    }
    module.hot.accept("./declaration.vue?vue&type=template&id=f8dd7832", function () {
      api.rerender('f8dd7832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EndUserViews/pickupManagement/declaration.vue"
export default component.exports